import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";

import BlogOne from "./components/Blog";

import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import Profile from "../src/components/Profile/Profile"
import NotFound from './components/NotFound';

import ShippingTwo from "./pages/ShippingTwoPage";

import ProductDetailsMaterialPage from "./pages/ProductDetailsMaterialPage";
import { AuthProvider } from "./context/AuthContext"; // adjust path as needed

import ComparisonPage from "./components/ComparisonPage";
import AboutUs from "./components/AboutUs";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Testimonials from "./components/Testimonials";
import BottomFooter2 from "./components/BottomFooterTwo";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import TermsAndConditions from "./components/TermsAndConditions";
import ReturnPolicy from "./components/ReturnPolicy";

function App() {
  return (
    <AuthProvider>

      <BrowserRouter>
        <RouteScrollToTop />
        <PhosphorIconInit />

        <Routes>
          
          <Route path="/profile" element={<Profile />} />

          <Route exact path='/' element={<HomePageOne />} />
          <Route exact path='/index-two' element={<HomePageTwo />} />
          <Route exact path='/index-three' element={<HomePageThree />} />
          <Route exact path='/shop' element={<ShopPage />} />
          <Route exact path='/about' element={<AboutUs />} />
          <Route exact path='/privacy' element={<PrivacyPolicy />} />
          <Route exact path='/testimonials' element={<Testimonials />} />
                    <Route exact path='/bottomfooter' element={<BottomFooter2 />} />
                    <Route exact path='/blog-one' element={<BlogOne/>} />
                                        <Route exact path='/FAQ' element={<FAQ/>} />



          <Route
            exact
            path='/product-details'
            element={<ProductDetailsPageOne />}
          />
          <Route
            exact
            path='/product-details-two'
            element={<ProductDetailsPageTwo />}
          />
          <Route
            exact
            path='/product-details-material'
            element={<ProductDetailsMaterialPage />}
          />

          <Route exact path='/cart' element={<CartPage />} />
          <Route exact path='/checkout' element={<CheckoutPage />} />
          <Route exact path='/become-seller' element={<BecomeSellerPage />} />
          <Route exact path='/wishlist' element={<WishlistPage />} />
          <Route exact path='/account' element={<AccountPage />} />
          <Route exact path='/shipping-policy' element={<ShippingTwo />} />
          <Route exact path='/terms-conditions' element={<TermsAndConditions />} />
          <Route exact path='/return-policy' element={<ReturnPolicy />} />


          

          <Route exact path='/contact' element={<Contact />} />
          <Route exact path='/vendor' element={<VendorPage />} />
          <Route exact path='/vendor-details' element={<VendorDetailsPage />} />
          <Route exact path='/vendor-two' element={<VendorTwoPage />} />
          <Route exact path='/comparison' element={<ComparisonPage />} />


          <Route
            exact
            path='/vendor-two-details'
            element={<VendorTwoDetailsPage />}
          />
          <Route path="*" element={<NotFound />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>

  );
}

export default App;
